export default __webpack_public_path__ + "static/media/nipple-verse.9d724cc2.png";